
import { Vue, Component } from 'vue-property-decorator'
import Layout from '@/types/layout'
import Column from '@/types/column'
import { can } from '@/globalFunctions'
@Component({
  methods: { can },
  components: {}
})

export default class LayoutShowElementsTab extends Vue {
  settings = {
    routeNames: { list: 'layouts', show: 'layoutShow', edit: 'layoutEdit' },
    routeParamKey: 'layoutId',
    functionNames: { setCurrent: 'setCurrentLayout', save: 'saveLayout' },
    getterNames: { current: 'currentLayout', loading: 'loadingLayout', errors: 'layoutErrors' }
  }

  columns:Column[] = [
    {
      title: 'Element',
      key: 'name',
      dataIndex: 'name'
    },
    {
      title: 'Commerciële naam',
      key: 'name_sales',
      dataIndex: 'name_sales'
    },
    {
      title: 'Groep',
      key: 'group_text',
      dataIndex: 'group_text'
    },
    {
      title: 'Positie',
      key: 'pivot.position',
      dataIndex: 'pivot.position'
    },
    {
      title: 'Actie\'s',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  onRowClick (rowData:{id:number}) : { on: { click: () => void }} {
    return {
      on: {
        click: () => {
          const keyboard = window.event as KeyboardEvent
          if (can('elements.view')) {
            const route = this.$router.resolve({ name: 'elementShow', params: { elementId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          }
        }
      }
    }
  }

  get currentItem () : Layout {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
